import React from "react";

import { CostDetailCharge } from "api/models";
import { GetCostDetailsResponseType } from "api/response";
import testIds from "constants/testIds";
import { formatPriceV2 } from "helpers/commonHelpers";
import { formatCostLineFormula, MEASUREMENT_UNIT_CHARGEABLE_WEIGHT } from "helpers/formatCostLineFormula";

interface CostChargesProps {
  costDetailsData: GetCostDetailsResponseType;
}

export default function CostCharges({ costDetailsData }: CostChargesProps) {
  const { quotation_cost_items }: any = costDetailsData?.costs ?? {};
  const {
    "Origin Charges": originCharges,
    Freight: freightCharges,
    "Destination Charges": destinationCharges,
  } = quotation_cost_items ?? {};

  const costCharges = [...(originCharges ?? []), ...(freightCharges ?? []), ...(destinationCharges ?? [])];
  if (!costCharges || costCharges.length === 0) return null;

  return (
    <>
      {Object.keys(quotation_cost_items || {}).map(
        (key) =>
          quotation_cost_items?.[key]?.length > 0 && (
            <React.Fragment key={key}>
              <tr>
                <th colSpan={3} className="cost-details__group">
                  {key}:
                </th>
              </tr>
              {quotation_cost_items?.[key]?.map((item: CostDetailCharge) => {
                const headerWeight = costDetailsData?.quote_measurement_summary?.chargeable_weight?.value;
                const formula = formatCostLineFormula({
                  ...item,
                  quantity:
                    item.measurement_unit === MEASUREMENT_UNIT_CHARGEABLE_WEIGHT && headerWeight != null
                      ? headerWeight
                      : item.quantity,
                  weight_unit:
                    costDetailsData?.quote_measurement_summary?.chargeable_weight_unit ||
                    costDetailsData?.quote_measurement_summary?.chargeable_weight?.unit,
                });
                return (
                  <tr key={item.id} data-testid={`${testIds.SHIPMENT_DASHBOARD_QUOTE_COST_ROW_PREFIX}${item.id}`}>
                    <td className="cost-details__charge text-wrap" style={{ width: "60%" }}>
                      {item.description}
                    </td>
                    <td className="cost-details__charge text-right text-wrap" style={{ width: "20%" }}>
                      {`${formatPriceV2(item.amount_origin)} ${item.currency_origin}`}
                      {formula ? (
                        <>
                          <br />
                          <span
                            className="text-secondary font-b3 text-wrap"
                            data-testid={`${testIds.SHIPMENT_DASHBOARD_QUOTE_COST_FORMULA_PREFIX}${item.id}`}
                          >
                            {formula}
                          </span>
                        </>
                      ) : null}
                    </td>
                    <td className="cost-details__charge text-right text-wrap" style={{ width: "20%" }}>{`${formatPriceV2(
                      item.amount_target,
                    )} ${item.target_currency_code}`}</td>
                  </tr>
                );
              })}
            </React.Fragment>
          ),
      )}
    </>
  );
}
